export default __webpack_public_path__ + "static/android-icon-192x192-cd1c226a1b9ccea46fb3e79f8b61273e.png";